import { render, staticRenderFns } from "./MoreView.vue?vue&type=template&id=933cbf86&scoped=true&"
import script from "./MoreView.vue?vue&type=script&lang=js&"
export * from "./MoreView.vue?vue&type=script&lang=js&"
import style0 from "./MoreView.vue?vue&type=style&index=0&id=933cbf86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933cbf86",
  null
  
)

export default component.exports